import _defineProperty from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ul li {\n        list-style: disc;\n        margin-left: 14px;\n    }\n    .error {\n        display: inline-block;\n        margin-top: 5px;\n    }\n    .submit-warning {\n        font-weight: bold;\n        text-align: left;\n        margin-top: 25px;\n    }\n    .submit-btn-wrapper {\n        display: flex;\n        justify-content: flex-end;\n        align-items: center;\n    }\n    .professional-user-fees {\n        border: 1px solid black;\n        border-radius: 5px;\n        padding: 25px;\n        margin: 25px 0 25px 0;\n        background-color: rgb(236, 236, 236, 0.2);\n    }\n    .professional-user-fees span {\n        font-weight: bold;\n    }\n    .professional-user-fees .professional-user-qualification {\n        font-weight: bold;\n    }\n    .professional-user-agreements {\n        margin-bottom: ", ";\n    }\n    .professional-user-agreements a {\n        display: inline-block;\n    }\n    ol li {\n        list-style: decimal;\n        margin-left: 17px;\n    }\n    .employment-data-form-groups {\n        margin: 25px 0;\n    }\n    .form-error-msg {\n        text-align: center;\n        width: 100%;\n    }\n    .btn-primary:disabled {\n        border-color: #ccc;\n    }\n    .btn-primary:disabled:hover {\n        background-color: #ccc;\n    }\n    .loading-container {\n        width: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n    .temp-delayed-quotes-warning {\n        font-weight: bold;\n    }\n    button.btn-dark:disabled:hover {\n        border-color: unset;\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ul li {\n        list-style: disc;\n        margin-left: 14px;\n    }\n    ul {\n        margin-bottom: 25px;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as tslib_1 from "tslib";
import React, { useState, useRef, useEffect, useMemo, Fragment } from 'react';
import useSWRMutation from 'swr/mutation';
import useSWR from 'swr';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { Button } from 'react-bootstrap';
import _ from 'lodash';
import styled from 'styled-components';
import { AllStates, AllYearsEmployed, Country, EmploymentType, EmploymentTypes, getGroupedCountryOptions, ResponseCodes } from '@tradingblock/types';
import { GetUserMarketDataEntitlementsUrl, SubmitMktDataUserProfileReviewUrl, UpdateAccountUrl } from '@tradingblock/api';
import { SelectDropdownField, StepperField, TextboxField } from '../localize/fields';
import { ExternalLink, Loading } from '../common';
import { FormGroup, Tooltip } from '../basic';
import { firstSetOfMarketDataQuestionnaireBooleanFormFields, secondSetOfMarketDataQuestionnaireBooleanFormFields } from '../../constants';
export var MARKET_DATA_QUESTIONNAIRE_HEADER = 'Market Data User Profile Review';
export var SUBMIT_WARNING = 'By submitting this form, you agree that all questions answered above and information provided are truthful and accurate.';
export var ELECTRONIC_DATA_AGREEMENT_VALIDATION_MSG = 'You must open and review the Electronic Data Agreement.';
export var GENERIC_SUBMISSION_ERROR_MSG = 'Something went wrong submitting the form. Please try submitting again.';
export var CONFIRM_CHANGES_BUTTON_TEXT = 'Confirm Changes';
export var EDIT_BUTTON_TEXT = 'Edit';
export var TEMP_DELAYED_QUOTES_WARNING = 'Based on the information provided above, you qualify as professional market data user. Following submission of this form, you will be entitled for delayed quotes until your real-time request is approved.';
var StyledDescription = styled.div(_templateObject());
export var MarketDataQuestionnaireDescription = function MarketDataQuestionnaireDescription() {
  return React.createElement(StyledDescription, null, React.createElement("p", null, "Please answer the questions below to verify your status as a professional or non-professional user of NYSE, AMEX, Nasdaq and OPRA market data. Please note:"), React.createElement("ul", null, React.createElement("li", null, "Delayed market data is provided at no cost to all users."), React.createElement("li", null, "Real-time market data is provided at no cost to all non-professional users."), React.createElement("li", null, "Real-time market data is provided at cost to all professional users.")));
};
var defaultInitialMarketDataQuestionnaireFormValues = {
  questions: {
    finraRelated: null,
    industryRelated: null,
    stakeHolder: null,
    govOfficial: null,
    foreignShellBank: null,
    nonPersonalUse: null,
    businessUse: null,
    secCftcRegistration: null,
    associationRegistration: null,
    jobFunctions: null,
    investmentProfessional: null,
    assetManager: null,
    capitalTrading: null,
    corporationTrading: null,
    profitSharing: null,
    benefitsReceived: null
  },
  realtimeRequested: null,
  employmentType: null,
  employer: null,
  jobPosition: null,
  occupation: null,
  employmentFunctions: null,
  yearsEmployed: null,
  employerAddress: {
    country: null,
    address1: null,
    address2: null,
    city: null,
    state: null,
    postalCode: null
  }
};
var sixthQuestionKey = Object.keys(firstSetOfMarketDataQuestionnaireBooleanFormFields)[5];

var createYesNoStepperFieldData = function createYesNoStepperFieldData(isDisabled) {
  return [{
    label: 'Yes',
    value: true,
    disabled: isDisabled
  }, {
    label: 'No',
    value: false,
    disabled: isDisabled
  }];
};

var StyledForm = styled.div(_templateObject2(), function (params) {
  return params.useCustomBtnPositioning ? '1rem' : '25px';
});
export var MarketDataQuestionnaireForm = function MarketDataQuestionnaireForm(_ref) {
  var api = _ref.api,
      rootRestHubUrl = _ref.rootRestHubUrl,
      onSubmissionFailure = _ref.onSubmissionFailure,
      onSubmissionSuccess = _ref.onSubmissionSuccess,
      useCustomBtnPositioning = _ref.useCustomBtnPositioning,
      useCustomErrorMsgPositioning = _ref.useCustomErrorMsgPositioning,
      setSubmitBtnRef = _ref.setSubmitBtnRef,
      setErrorMsg = _ref.setErrorMsg,
      setSubmitBtnDisabled = _ref.setSubmitBtnDisabled,
      setSubmitBtnText = _ref.setSubmitBtnText,
      setShouldRefetchProfileData = _ref.setShouldRefetchProfileData,
      setShouldRefetchAccountManagementDetailsData = _ref.setShouldRefetchAccountManagementDetailsData,
      setShowTempDelayedQuotesWarningWithCustomPositioning = _ref.setShowTempDelayedQuotesWarningWithCustomPositioning,
      accountId = _ref.accountId,
      accountIdOfAuthUserIsSameAsSelectedAccountId = _ref.accountIdOfAuthUserIsSameAsSelectedAccountId;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      showSecondSetOfBooleanFields = _useState2[0],
      setShowSecondSetOfBooleanFields = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      isProfessionalUser = _useState4[0],
      setIsProfessionalUser = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      isRequestingRealTimeQuotes = _useState6[0],
      setIsRequestingRealTimeQuotes = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      formErrMsg = _useState8[0],
      setFormErrMsg = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      hasClickedOnExchangeDataAgreementLink = _useState10[0],
      setHasClickedOnExchangeDataAgreementLink = _useState10[1];

  var _useState11 = useState(null),
      _useState12 = _slicedToArray(_useState11, 2),
      isEmployed = _useState12[0],
      setIsEmployed = _useState12[1];

  var _useState13 = useState(null),
      _useState14 = _slicedToArray(_useState13, 2),
      isCountryUs = _useState14[0],
      setIsCountryUs = _useState14[1];

  var _useState15 = useState(defaultInitialMarketDataQuestionnaireFormValues),
      _useState16 = _slicedToArray(_useState15, 2),
      initialMarketDataQuestionnaireFormValues = _useState16[0],
      setInitialMarketDataQuestionnaireFormValues = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      previousFormDataSet = _useState18[0],
      setPreviousFormDataSet = _useState18[1];

  var _useState19 = useState(false),
      _useState20 = _slicedToArray(_useState19, 2),
      changesMadeToForm = _useState20[0],
      setChangesMadeToForm = _useState20[1];

  var _useState21 = useState(null),
      _useState22 = _slicedToArray(_useState21, 2),
      potentiallyPro = _useState22[0],
      setPotentiallyPro = _useState22[1];

  var _useState23 = useState(false),
      _useState24 = _slicedToArray(_useState23, 2),
      showElectronicDataAgreementValidationMsg = _useState24[0],
      setShowElectronicDataAgreementValidationMsg = _useState24[1];

  var _useState25 = useState(false),
      _useState26 = _slicedToArray(_useState25, 2),
      loadingAndValidatingCheckPassed = _useState26[0],
      setLoadingAndValidatingCheckPassed = _useState26[1];

  var _useState27 = useState(false),
      _useState28 = _slicedToArray(_useState27, 2),
      showTempDelayedQuotesWarning = _useState28[0],
      setShowTempDelayedQuotesWarning = _useState28[1];

  var _useSWRMutation = useSWRMutation("".concat(rootRestHubUrl, "/").concat(SubmitMktDataUserProfileReviewUrl), function (_url, _ref2) {
    var arg = _ref2.arg;
    return api.entitlements.submitMktDataUserProfileReview(arg.submitMktDataUserProfileReviewRequestPayload);
  }),
      triggerSubmitMktDataUserProfileReview = _useSWRMutation.trigger;

  var _useSWRMutation2 = useSWRMutation("".concat(rootRestHubUrl, "/").concat(UpdateAccountUrl), function (_url, _ref3) {
    var arg = _ref3.arg;
    return api.accounts.update(accountId, arg.updateAccountEmploymentInfoRequestPayload);
  }),
      triggerUpdateAccount = _useSWRMutation2.trigger;

  var _useSWR = useSWR("".concat(rootRestHubUrl, "/").concat(GetUserMarketDataEntitlementsUrl), function () {
    return api.entitlements.getUserMarketDataEntitlements();
  }, {
    revalidateOnFocus: false,
    shouldRetryOnError: false
  }),
      isLoadingUserMarketDataEntitlementsData = _useSWR.isLoading,
      getUserMarketDataEntitlementsResponse = _useSWR.data,
      errorGettingUserMarketDataEntitlementsData = _useSWR.error,
      isValidatingUserMarketDataEntitlementsData = _useSWR.isValidating;

  var prevIsRequestingRealTimeQuotes = useRef(null);
  var electronicDataAgreementDivRef = useRef(null);
  var prevIsLoadingUserMarketDataEntitlementsData = useRef(isLoadingUserMarketDataEntitlementsData);
  var prevIsValidatingUserMarketDataEntitlementsData = useRef(isValidatingUserMarketDataEntitlementsData);
  useEffect(function () {
    if (!isLoadingUserMarketDataEntitlementsData && prevIsLoadingUserMarketDataEntitlementsData.current || !isValidatingUserMarketDataEntitlementsData && prevIsValidatingUserMarketDataEntitlementsData.current || !isLoadingUserMarketDataEntitlementsData && prevIsLoadingUserMarketDataEntitlementsData.current && !isValidatingUserMarketDataEntitlementsData && prevIsValidatingUserMarketDataEntitlementsData.current) {
      setLoadingAndValidatingCheckPassed(true);
    }
  }, [isLoadingUserMarketDataEntitlementsData, isValidatingUserMarketDataEntitlementsData, prevIsLoadingUserMarketDataEntitlementsData, prevIsValidatingUserMarketDataEntitlementsData]);
  useEffect(function () {
    prevIsValidatingUserMarketDataEntitlementsData.current = isValidatingUserMarketDataEntitlementsData;
  }, [isValidatingUserMarketDataEntitlementsData]);
  useEffect(function () {
    prevIsLoadingUserMarketDataEntitlementsData.current = isLoadingUserMarketDataEntitlementsData;
  }, [isLoadingUserMarketDataEntitlementsData]);
  useEffect(function () {
    if (getUserMarketDataEntitlementsResponse && !errorGettingUserMarketDataEntitlementsData && getUserMarketDataEntitlementsResponse.payload && loadingAndValidatingCheckPassed) {
      if (getUserMarketDataEntitlementsResponse.responseCode === 0) {
        var _a = getUserMarketDataEntitlementsResponse.payload,
            _potentiallyPro = _a.potentiallyPro,
            userMarketDataEntitlementsDataExcludingPotentiallyPro = tslib_1.__rest(_a, ["potentiallyPro"]);

        var nonPersonalUse = null;

        if (_potentiallyPro) {
          nonPersonalUse = true;
        } else {
          if (userMarketDataEntitlementsDataExcludingPotentiallyPro.questions.nonPersonalUse === false || userMarketDataEntitlementsDataExcludingPotentiallyPro.questions.nonPersonalUse === true) {
            nonPersonalUse = userMarketDataEntitlementsDataExcludingPotentiallyPro.questions.nonPersonalUse;
          } else {
            nonPersonalUse = defaultInitialMarketDataQuestionnaireFormValues.questions.nonPersonalUse;
          }
        }

        setInitialMarketDataQuestionnaireFormValues(Object.assign({}, defaultInitialMarketDataQuestionnaireFormValues, userMarketDataEntitlementsDataExcludingPotentiallyPro, {
          questions: Object.keys(userMarketDataEntitlementsDataExcludingPotentiallyPro.questions).length === 0 ? Object.assign({}, defaultInitialMarketDataQuestionnaireFormValues.questions, {
            nonPersonalUse: nonPersonalUse
          }) : Object.assign({}, defaultInitialMarketDataQuestionnaireFormValues.questions, userMarketDataEntitlementsDataExcludingPotentiallyPro.questions, {
            nonPersonalUse: nonPersonalUse
          })
        }, userMarketDataEntitlementsDataExcludingPotentiallyPro.employmentType !== EmploymentType.Employed && {
          employerAddress: defaultInitialMarketDataQuestionnaireFormValues.employerAddress,
          employer: defaultInitialMarketDataQuestionnaireFormValues.employer,
          jobPosition: defaultInitialMarketDataQuestionnaireFormValues.jobPosition,
          employmentFunctions: defaultInitialMarketDataQuestionnaireFormValues.employmentFunctions,
          occupation: defaultInitialMarketDataQuestionnaireFormValues.occupation,
          yearsEmployed: defaultInitialMarketDataQuestionnaireFormValues.yearsEmployed
        }));
        setPreviousFormDataSet(true);
        setPotentiallyPro(_potentiallyPro);
      }
    }
  }, [getUserMarketDataEntitlementsResponse, errorGettingUserMarketDataEntitlementsData, loadingAndValidatingCheckPassed]);
  useEffect(function () {
    prevIsRequestingRealTimeQuotes.current = isRequestingRealTimeQuotes;
  }, [isRequestingRealTimeQuotes]);
  useEffect(function () {
    if (hasClickedOnExchangeDataAgreementLink === false && isRequestingRealTimeQuotes) {
      setShowElectronicDataAgreementValidationMsg(true);
    } else {
      setShowElectronicDataAgreementValidationMsg(false);
    }
  }, [hasClickedOnExchangeDataAgreementLink, isRequestingRealTimeQuotes]);
  useEffect(function () {
    if (useCustomErrorMsgPositioning) {
      if (showElectronicDataAgreementValidationMsg) {
        setErrorMsg(ELECTRONIC_DATA_AGREEMENT_VALIDATION_MSG);
        return;
      }

      if (formErrMsg) {
        setErrorMsg(formErrMsg);
        return;
      }

      setErrorMsg('');
    }
  }, [formErrMsg, showElectronicDataAgreementValidationMsg]);
  useEffect(function () {
    if (isRequestingRealTimeQuotes && isProfessionalUser) {
      if (setShowTempDelayedQuotesWarningWithCustomPositioning) {
        setShowTempDelayedQuotesWarningWithCustomPositioning(true);
      } else {
        setShowTempDelayedQuotesWarning(true);
      }
    } else {
      if (setShowTempDelayedQuotesWarningWithCustomPositioning) {
        setShowTempDelayedQuotesWarningWithCustomPositioning(false);
      } else {
        setShowTempDelayedQuotesWarning(false);
      }
    }
  }, [isRequestingRealTimeQuotes, isProfessionalUser]);

  var onSubmit =
  /*#__PURE__*/
  function () {
    var _ref5 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(values, _ref4) {
      var setSubmitting, employerAddress, employer, jobPosition, employmentType, yearsEmployed, cleanedEmploymentInfoData, updateAccountEmploymentInfoRequestPayload, _ref6, updateAccountEmploymentInfoResponseCode, occupation, employmentFunctions, questions, realtimeRequested, cleanedDataForSubmitMktDataUserProfileReviewRequest, _ref7, submitMktDataUserProfileReviewResponseCode, errorMessage;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setSubmitting = _ref4.setSubmitting;
              setFormErrMsg('');

              if (!(!hasClickedOnExchangeDataAgreementLink && isRequestingRealTimeQuotes)) {
                _context.next = 7;
                break;
              }

              electronicDataAgreementDivRef && electronicDataAgreementDivRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
              setHasClickedOnExchangeDataAgreementLink(false);
              setSubmitting(false);
              return _context.abrupt("return");

            case 7:
              _context.prev = 7;

              if (!isRequestingRealTimeQuotes) {
                _context.next = 22;
                break;
              }

              employerAddress = values.employerAddress, employer = values.employer, jobPosition = values.jobPosition, employmentType = values.employmentType, yearsEmployed = values.yearsEmployed;
              cleanedEmploymentInfoData = {
                employerAddress: !isEmployed ? null : Object.assign({}, employerAddress, {
                  address1: employerAddress && employerAddress.address1 && employerAddress.address1.trim(),
                  address2: employerAddress && employerAddress.address2 && employerAddress.address2.trim(),
                  city: employerAddress && employerAddress.city && employerAddress.city.trim(),
                  postalCode: employerAddress && employerAddress.postalCode && employerAddress.postalCode.trim(),
                  state: employerAddress && employerAddress.state && employerAddress.state.trim()
                }),
                employer: employer && employer.trim(),
                jobPosition: jobPosition && jobPosition.trim(),
                employmentType: employmentType,
                yearsEmployed: yearsEmployed
              };
              updateAccountEmploymentInfoRequestPayload = {
                accountHolder: cleanedEmploymentInfoData,
                holder: 0,
                item: 'Employment'
              };
              _context.next = 14;
              return triggerUpdateAccount({
                updateAccountEmploymentInfoRequestPayload: updateAccountEmploymentInfoRequestPayload
              });

            case 14:
              _ref6 = _context.sent;
              updateAccountEmploymentInfoResponseCode = _ref6.responseCode;

              if (!(updateAccountEmploymentInfoResponseCode !== 0)) {
                _context.next = 22;
                break;
              }

              if (!ResponseCodes[updateAccountEmploymentInfoResponseCode]) {
                _context.next = 21;
                break;
              }

              throw new Error(ResponseCodes[updateAccountEmploymentInfoResponseCode].description);

            case 21:
              throw new Error(GENERIC_SUBMISSION_ERROR_MSG);

            case 22:
              occupation = values.occupation, employmentFunctions = values.employmentFunctions, questions = values.questions, realtimeRequested = values.realtimeRequested;
              cleanedDataForSubmitMktDataUserProfileReviewRequest = {
                questions: questions,
                realtimeRequested: realtimeRequested,
                occupation: occupation && occupation.trim(),
                employmentFunctions: employmentFunctions && employmentFunctions.trim()
              };
              _context.next = 26;
              return triggerSubmitMktDataUserProfileReview({
                submitMktDataUserProfileReviewRequestPayload: cleanedDataForSubmitMktDataUserProfileReviewRequest
              });

            case 26:
              _ref7 = _context.sent;
              submitMktDataUserProfileReviewResponseCode = _ref7.responseCode;

              if (!(submitMktDataUserProfileReviewResponseCode !== 0)) {
                _context.next = 35;
                break;
              }

              if (onSubmissionFailure) {
                onSubmissionFailure(submitMktDataUserProfileReviewResponseCode);
              }

              if (!ResponseCodes[submitMktDataUserProfileReviewResponseCode]) {
                _context.next = 34;
                break;
              }

              throw new Error(ResponseCodes[submitMktDataUserProfileReviewResponseCode].description);

            case 34:
              throw new Error(GENERIC_SUBMISSION_ERROR_MSG);

            case 35:
              if (submitMktDataUserProfileReviewResponseCode === 0) {
                setShouldRefetchProfileData && setShouldRefetchProfileData(true);

                if (accountIdOfAuthUserIsSameAsSelectedAccountId) {
                  setShouldRefetchAccountManagementDetailsData && setShouldRefetchAccountManagementDetailsData(true);
                }

                onSubmissionSuccess();
              }

              _context.next = 44;
              break;

            case 38:
              _context.prev = 38;
              _context.t0 = _context["catch"](7);
              errorMessage = '';

              if (_context.t0 instanceof Error && _context.t0.message && Object.keys(_context.t0).length === 1) {
                errorMessage = _context.t0.message;
              } else {
                errorMessage = GENERIC_SUBMISSION_ERROR_MSG;
              }

              setFormErrMsg(errorMessage);
              setSubmitting(false);

            case 44:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[7, 38]]);
    }));

    return function onSubmit(_x, _x2) {
      return _ref5.apply(this, arguments);
    };
  }();

  var determineIfProfessionalUser = function determineIfProfessionalUser(values) {
    return setIsProfessionalUser(!!Object.keys(firstSetOfMarketDataQuestionnaireBooleanFormFields).find(function (booleanFormField) {
      return values.questions[booleanFormField];
    }));
  };

  var formFieldValidationSchema = Yup.string().nullable().trim().required('This field is required.');
  var address1And2FormFieldValidationSchema = Yup.string().matches(/^[\u0020-\u007E]*$/, {
    excludeEmptyString: true,
    message: 'Please make sure the address field above is valid.'
  }).max(30, 'This field must be no more than 30 characters, including spaces.');
  var postalCodeFormFieldValidationSchema = Yup.string().matches(/^\d{5}(?:[-]\d{4})?$/, {
    excludeEmptyString: true,
    message: 'Please make sure the postal code above is valid.'
  });

  var handleAgreementClick = function handleAgreementClick() {
    setHasClickedOnExchangeDataAgreementLink(true);
  };

  return React.createElement(StyledForm, {
    useCustomBtnPositioning: useCustomBtnPositioning
  }, React.createElement("div", {
    className: "market-data-questionnaire-form"
  }, isLoadingUserMarketDataEntitlementsData && React.createElement("div", {
    className: "loading-container"
  }, React.createElement(Loading, null)), loadingAndValidatingCheckPassed && (getUserMarketDataEntitlementsResponse && getUserMarketDataEntitlementsResponse.responseCode === 0 && previousFormDataSet || !getUserMarketDataEntitlementsResponse || getUserMarketDataEntitlementsResponse.responseCode !== 0 || errorGettingUserMarketDataEntitlementsData) && React.createElement(Formik, {
    validateOnBlur: true,
    validateOnChange: true,
    validationSchema: Yup.object().shape(Object.assign({
      realtimeRequested: formFieldValidationSchema,
      questions: Yup.object().shape(Object.assign({
        finraRelated: formFieldValidationSchema,
        industryRelated: formFieldValidationSchema,
        stakeHolder: formFieldValidationSchema,
        govOfficial: formFieldValidationSchema,
        foreignShellBank: formFieldValidationSchema,
        nonPersonalUse: formFieldValidationSchema
      }, showSecondSetOfBooleanFields && {
        businessUse: formFieldValidationSchema,
        associationRegistration: formFieldValidationSchema,
        jobFunctions: formFieldValidationSchema,
        investmentProfessional: formFieldValidationSchema,
        secCftcRegistration: formFieldValidationSchema,
        capitalTrading: formFieldValidationSchema,
        corporationTrading: formFieldValidationSchema,
        profitSharing: formFieldValidationSchema,
        benefitsReceived: formFieldValidationSchema,
        assetManager: formFieldValidationSchema
      }))
    }, isRequestingRealTimeQuotes && Object.assign({
      employmentType: formFieldValidationSchema
    }, isEmployed && {
      employerAddress: Yup.object().shape(Object.assign({
        address1: formFieldValidationSchema.concat(address1And2FormFieldValidationSchema),
        address2: Yup.string().nullable().trim().concat(address1And2FormFieldValidationSchema),
        city: formFieldValidationSchema,
        country: formFieldValidationSchema
      }, (isCountryUs || isCountryUs === null) && {
        postalCode: formFieldValidationSchema.concat(postalCodeFormFieldValidationSchema),
        state: formFieldValidationSchema
      })),
      employmentFunctions: formFieldValidationSchema,
      jobPosition: formFieldValidationSchema,
      occupation: formFieldValidationSchema,
      employer: formFieldValidationSchema,
      yearsEmployed: formFieldValidationSchema
    }))),
    initialValues: initialMarketDataQuestionnaireFormValues,
    onSubmit: onSubmit
  }, function (_ref8) {
    var values = _ref8.values,
        isSubmitting = _ref8.isSubmitting,
        resetForm = _ref8.resetForm,
        errors = _ref8.errors,
        isValid = _ref8.isValid,
        isValidating = _ref8.isValidating;
    useEffect(function () {
      if (!isValid && !isValidating && isSubmitting) {
        var inputName = '';
        Object.keys(defaultInitialMarketDataQuestionnaireFormValues).find(function (formInputKey) {
          var rootErrorKey = Object.keys(errors).find(function (errorKey) {
            return errorKey === formInputKey;
          });

          if (rootErrorKey) {
            if (typeof errors[rootErrorKey] === 'object') {
              inputName = Object.keys(defaultInitialMarketDataQuestionnaireFormValues[rootErrorKey]).find(function (formInputKey) {
                return !!Object.keys(errors[rootErrorKey]).find(function (errorKey) {
                  return errorKey === formInputKey;
                });
              });
              return true;
            }

            inputName = formInputKey;
            return true;
          }

          return false;
        });

        if (inputName) {
          if (Object.keys(defaultInitialMarketDataQuestionnaireFormValues.questions).includes(inputName)) {
            inputName = "questions.".concat(inputName);
          }

          if (Object.keys(defaultInitialMarketDataQuestionnaireFormValues.employerAddress).includes(inputName)) {
            inputName = "employerAddress.".concat(inputName);
          }

          var elementToScrollTo = document.querySelector("input[id='".concat(inputName, "']")) || document.getElementById("btn-".concat(inputName, "-0"));

          if (elementToScrollTo) {
            elementToScrollTo.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
          }
        }
      }
    }, [errors, isValid, isValidating, isSubmitting]); // This section will cleanup the form fields if they are hidden and set back to the null value.
    // Or if the field is visible the value of the field will be set to the form value or the initial form data state value.

    useEffect(function () {
      var getBooleanFieldValue = function getBooleanFieldValue(booleanFormFieldKey) {
        if (values.questions[booleanFormFieldKey] === false || values.questions[booleanFormFieldKey] === true) {
          return values.questions[booleanFormFieldKey];
        }

        if (initialMarketDataQuestionnaireFormValues.questions[booleanFormFieldKey] === false || initialMarketDataQuestionnaireFormValues.questions[booleanFormFieldKey] === true) {
          return initialMarketDataQuestionnaireFormValues.questions[booleanFormFieldKey];
        }

        return null;
      };

      resetForm({
        values: Object.assign({}, values, {
          questions: Object.assign({}, values.questions, showSecondSetOfBooleanFields !== null && Object.keys(secondSetOfMarketDataQuestionnaireBooleanFormFields).reduce(function (accumulator, booleanFormFieldKey) {
            return Object.assign({}, accumulator, _defineProperty({}, booleanFormFieldKey, showSecondSetOfBooleanFields ? getBooleanFieldValue(booleanFormFieldKey) : defaultInitialMarketDataQuestionnaireFormValues.questions[booleanFormFieldKey]));
          }, {}))
        }, isRequestingRealTimeQuotes !== null && {
          employmentType: isRequestingRealTimeQuotes ? values.employmentType || initialMarketDataQuestionnaireFormValues.employmentType : defaultInitialMarketDataQuestionnaireFormValues.employmentType
        }, isEmployed !== null && {
          employer: isEmployed ? values.employer || initialMarketDataQuestionnaireFormValues.employer : defaultInitialMarketDataQuestionnaireFormValues.employer,
          occupation: isEmployed ? values.occupation || initialMarketDataQuestionnaireFormValues.occupation : defaultInitialMarketDataQuestionnaireFormValues.occupation,
          employmentFunctions: isEmployed ? values.employmentFunctions || initialMarketDataQuestionnaireFormValues.employmentFunctions : defaultInitialMarketDataQuestionnaireFormValues.employmentFunctions,
          jobPosition: isEmployed ? values.jobPosition || initialMarketDataQuestionnaireFormValues.jobPosition : defaultInitialMarketDataQuestionnaireFormValues.jobPosition,
          yearsEmployed: isEmployed ? values.yearsEmployed || initialMarketDataQuestionnaireFormValues.yearsEmployed : defaultInitialMarketDataQuestionnaireFormValues.yearsEmployed,
          employerAddress: isEmployed ? values.employerAddress && !!Object.keys(values.employerAddress).find(function (employerAddressKey) {
            return values.employerAddress && !!values.employerAddress[employerAddressKey];
          }) && values.employerAddress || initialMarketDataQuestionnaireFormValues.employerAddress : defaultInitialMarketDataQuestionnaireFormValues.employerAddress
        })
      });
    }, [showSecondSetOfBooleanFields, isEmployed, isRequestingRealTimeQuotes, initialMarketDataQuestionnaireFormValues]);
    useEffect(function () {
      return setShowSecondSetOfBooleanFields(values.questions[sixthQuestionKey]);
    }, [values.questions[sixthQuestionKey]]);
    useEffect(function () {
      return determineIfProfessionalUser(values);
    }, [values.questions.finraRelated, values.questions.industryRelated, values.questions.stakeHolder, values.questions.govOfficial, values.questions.foreignShellBank, values.questions.nonPersonalUse]);
    useEffect(function () {
      return setIsRequestingRealTimeQuotes(values.realtimeRequested);
    }, [values.realtimeRequested]);
    useEffect(function () {
      return setIsEmployed(values.employmentType === EmploymentType.Employed);
    }, [values.employmentType]);
    useEffect(function () {
      // This will reset if they have viewed the exchange data agreement if the isRequestingRealTimeQuotes state changes.
      if (!isRequestingRealTimeQuotes && prevIsRequestingRealTimeQuotes || isRequestingRealTimeQuotes && !prevIsRequestingRealTimeQuotes) {
        setHasClickedOnExchangeDataAgreementLink(null);
      }
    }, [isRequestingRealTimeQuotes]);
    useEffect(function () {
      if (!values.employerAddress || values.employerAddress && !values.employerAddress.country) {
        setIsCountryUs(null);
      } else if (values.employerAddress && values.employerAddress.country === Country.UnitedStatesOfAmerica) {
        setIsCountryUs(true);
      } else if (values.employerAddress && values.employerAddress.country !== Country.UnitedStatesOfAmerica) {
        setIsCountryUs(false);
      }
    }, [values.employerAddress && values.employerAddress.country]); // Whenever there is a change in the form data do a check to see
    // if the data is different than the initial form data.
    // This will dictate the form button text.

    useEffect(function () {
      var getBooleanFieldValue = function getBooleanFieldValue(booleanFormFieldKey) {
        if (initialMarketDataQuestionnaireFormValues.questions[booleanFormFieldKey] === true || initialMarketDataQuestionnaireFormValues.questions[booleanFormFieldKey] === false) {
          return initialMarketDataQuestionnaireFormValues.questions[booleanFormFieldKey];
        }

        return null;
      };

      var modifiedInitialMarketDataQuestionnaireFormValues = Object.assign({}, initialMarketDataQuestionnaireFormValues, {
        questions: Object.assign({}, initialMarketDataQuestionnaireFormValues.questions, showSecondSetOfBooleanFields !== null && Object.keys(secondSetOfMarketDataQuestionnaireBooleanFormFields).reduce(function (accumulator, booleanFormFieldKey) {
          return Object.assign({}, accumulator, _defineProperty({}, booleanFormFieldKey, showSecondSetOfBooleanFields ? getBooleanFieldValue(booleanFormFieldKey) : defaultInitialMarketDataQuestionnaireFormValues.questions[booleanFormFieldKey]));
        }, {}))
      }, isRequestingRealTimeQuotes !== null && {
        employmentType: isRequestingRealTimeQuotes ? initialMarketDataQuestionnaireFormValues.employmentType : defaultInitialMarketDataQuestionnaireFormValues.employmentType
      }, isEmployed !== null && {
        employer: isEmployed ? initialMarketDataQuestionnaireFormValues.employer : defaultInitialMarketDataQuestionnaireFormValues.employer,
        occupation: isEmployed ? initialMarketDataQuestionnaireFormValues.occupation : defaultInitialMarketDataQuestionnaireFormValues.occupation,
        employmentFunctions: isEmployed ? initialMarketDataQuestionnaireFormValues.employmentFunctions : defaultInitialMarketDataQuestionnaireFormValues.employmentFunctions,
        jobPosition: isEmployed ? initialMarketDataQuestionnaireFormValues.jobPosition : defaultInitialMarketDataQuestionnaireFormValues.jobPosition,
        yearsEmployed: isEmployed ? initialMarketDataQuestionnaireFormValues.yearsEmployed : defaultInitialMarketDataQuestionnaireFormValues.yearsEmployed,
        employerAddress: isEmployed ? initialMarketDataQuestionnaireFormValues.employerAddress && !!Object.keys(initialMarketDataQuestionnaireFormValues.employerAddress).find(function (employerAddressKey) {
          return initialMarketDataQuestionnaireFormValues.employerAddress && !!initialMarketDataQuestionnaireFormValues.employerAddress[employerAddressKey];
        }) && initialMarketDataQuestionnaireFormValues.employerAddress : defaultInitialMarketDataQuestionnaireFormValues.employerAddress
      });

      if (!_.isEqual(modifiedInitialMarketDataQuestionnaireFormValues, values) && !changesMadeToForm) {
        setChangesMadeToForm(true);
      } else if (_.isEqual(modifiedInitialMarketDataQuestionnaireFormValues, values) && changesMadeToForm) {
        setChangesMadeToForm(false);
      }
    }, [values, initialMarketDataQuestionnaireFormValues]);
    var submitButtonText = useMemo(function () {
      if (changesMadeToForm) {
        return CONFIRM_CHANGES_BUTTON_TEXT;
      }

      if (useCustomBtnPositioning) {
        if (isSubmitting) {
          return 'Editing';
        }

        return EDIT_BUTTON_TEXT;
      }

      if (isSubmitting) {
        return 'Submitting';
      }

      return 'Submit';
    }, [changesMadeToForm, useCustomBtnPositioning, isSubmitting]);
    return React.createElement(Form, {
      translate: undefined
    }, Object.keys(firstSetOfMarketDataQuestionnaireBooleanFormFields).map(function (booleanFormFieldKey) {
      return React.createElement(Fragment, {
        key: booleanFormFieldKey
      }, (booleanFormFieldKey !== sixthQuestionKey || booleanFormFieldKey === sixthQuestionKey && !potentiallyPro) && React.createElement(FormGroup, null, React.createElement("label", {
        htmlFor: "questions.".concat(booleanFormFieldKey)
      }, firstSetOfMarketDataQuestionnaireBooleanFormFields[booleanFormFieldKey]), React.createElement(Field, {
        id: "questions.".concat(booleanFormFieldKey),
        name: "questions.".concat(booleanFormFieldKey),
        component: StepperField,
        options: createYesNoStepperFieldData(isSubmitting)
      })), booleanFormFieldKey === sixthQuestionKey && potentiallyPro && React.createElement(FormGroup, null, React.createElement(Tooltip, {
        effect: "solid",
        place: "top",
        content: 'It has been determined you are a potentially pro user. Because of this the answer to this question must be "Yes".',
        id: booleanFormFieldKey
      }, React.createElement("label", {
        htmlFor: "questions.".concat(booleanFormFieldKey)
      }, firstSetOfMarketDataQuestionnaireBooleanFormFields[booleanFormFieldKey]), React.createElement(Field, {
        id: "questions.".concat(booleanFormFieldKey),
        name: "questions.".concat(booleanFormFieldKey),
        component: StepperField,
        options: createYesNoStepperFieldData(true)
      }))));
    }), showSecondSetOfBooleanFields && React.createElement(React.Fragment, null, Object.keys(secondSetOfMarketDataQuestionnaireBooleanFormFields).map(function (booleanFormFieldKey) {
      return React.createElement(FormGroup, {
        key: booleanFormFieldKey
      }, React.createElement("label", {
        htmlFor: booleanFormFieldKey
      }, secondSetOfMarketDataQuestionnaireBooleanFormFields[booleanFormFieldKey]), React.createElement(Field, {
        id: "questions.".concat(booleanFormFieldKey),
        name: "questions.".concat(booleanFormFieldKey),
        component: StepperField,
        options: createYesNoStepperFieldData(isSubmitting)
      }));
    })), React.createElement(FormGroup, {
      className: "quotes"
    }, React.createElement("label", {
      htmlFor: "realtimeRequested"
    }, "Select whether you wish to receive Real-time or Delayed quotes:"), React.createElement(Field, {
      id: "realtimeRequested",
      name: "realtimeRequested",
      component: StepperField,
      options: [{
        label: 'Delayed quotes (Free to all users)',
        value: false,
        disabled: isSubmitting
      }, {
        label: 'Real-time quotes (Free to non-pro users)',
        value: true,
        disabled: isSubmitting
      }]
    })), isProfessionalUser && isRequestingRealTimeQuotes && React.createElement("div", {
      className: "professional-user-fees"
    }, React.createElement("p", {
      className: "professional-user-qualification"
    }, "Based on the preceding information you supplied as part of this account application, you or the entity applying for this brokerage account qualifies as a \"Professional User\" as defined by the NYSE, AMEX, NASDAQ and the US options exchanges."), React.createElement("p", null, "Exchanges define a \"Professional User\" as an individual or entity that meets any one of the following qualifications:"), React.createElement("ol", null, React.createElement("li", null, "An employee or a member of any stock exchange or of any business registered under any securities law or regulation; or"), React.createElement("li", null, "An individual or entity trading in the account as a paid agent for a third party; or"), React.createElement("li", null, "An individual or entity whose account is in the name of a corporation, partnership or sole proprietorship.")), React.createElement("p", null, React.createElement("span", null, "Professional User Data Fees May Apply."), " Professional Users must choose to receive real-time or 15-minute delayed market quotes. Delayed market quotes are provided free of charge. Professional Users selecting real-time market quotes will be charged the following monthly data exchange fees:"), React.createElement("ul", null, React.createElement("li", null, "NYSE - $45.00"), React.createElement("li", null, "AMEX - $23.00"), React.createElement("li", null, "NASDAQ - $23.00"), React.createElement("li", null, "OPRA - $31.50")), React.createElement("p", null, "All fees and applicable taxes for real-time market quotes are charged in U.S. Dollars and are automatically deducted from your brokerage account each month and remitted to the exchange on your behalf. Fees are subject to change on a minimum of 60 days notice.")), isRequestingRealTimeQuotes && React.createElement("div", {
      className: "employment-data-form-groups"
    }, React.createElement("h4", null, "Employment Information"), React.createElement(FormGroup, null, React.createElement(Field, {
      component: SelectDropdownField,
      isSearchable: false,
      id: "employmentType",
      name: "employmentType",
      options: EmploymentTypes,
      label: "Employment Status",
      disabled: isSubmitting
    })), isEmployed && React.createElement(React.Fragment, null, React.createElement(FormGroup, null, React.createElement(Field, {
      component: TextboxField,
      id: "employer",
      name: "employer",
      label: "Employer Name",
      disabled: isSubmitting
    })), React.createElement(FormGroup, null, React.createElement(Field, {
      component: TextboxField,
      id: "jobPosition",
      name: "jobPosition",
      label: "Job Title",
      disabled: isSubmitting
    })), React.createElement(FormGroup, null, React.createElement(Field, {
      component: TextboxField,
      id: "occupation",
      name: "occupation",
      label: "Employment Occupation",
      disabled: isSubmitting
    })), React.createElement(FormGroup, null, React.createElement(Field, {
      component: TextboxField,
      id: "employmentFunctions",
      name: "employmentFunctions",
      label: "Employment Function",
      disabled: isSubmitting
    })), React.createElement(FormGroup, null, React.createElement(Field, {
      component: SelectDropdownField,
      isSearchable: false,
      id: "yearsEmployed",
      name: "yearsEmployed",
      options: AllYearsEmployed,
      label: "Years Employed",
      disabled: isSubmitting
    })), React.createElement("h5", null, "Employer Address"), React.createElement(FormGroup, null, React.createElement(Field, {
      component: SelectDropdownField,
      name: "employerAddress.country",
      id: "employerAddress.country",
      label: "Country",
      options: getGroupedCountryOptions(),
      optionsDefaultLabelId: "country",
      disabled: isSubmitting
    })), React.createElement(FormGroup, null, React.createElement(Field, {
      component: TextboxField,
      name: "employerAddress.address1",
      id: "employerAddress.address1",
      label: "Address 1",
      disabled: isSubmitting
    })), React.createElement(FormGroup, null, React.createElement(Field, {
      component: TextboxField,
      name: "employerAddress.address2",
      id: "employerAddress.address2",
      label: "Address 2",
      disabled: isSubmitting
    })), React.createElement(FormGroup, null, React.createElement(Field, {
      component: TextboxField,
      name: "employerAddress.city",
      id: "employerAddress.city",
      label: "City",
      disabled: isSubmitting
    })), (isCountryUs || isCountryUs === null) && React.createElement(FormGroup, null, React.createElement(Field, {
      component: SelectDropdownField,
      name: "employerAddress.state",
      id: "employerAddress.state",
      label: "State",
      options: AllStates,
      optionsDefaultLabelId: "state",
      disabled: isSubmitting
    })), !isCountryUs && isCountryUs !== null && React.createElement(FormGroup, null, React.createElement(Field, {
      component: TextboxField,
      name: "employerAddress.state",
      id: "employerAddress.state",
      label: "Province",
      disabled: isSubmitting
    })), React.createElement(FormGroup, null, React.createElement(Field, {
      component: TextboxField,
      name: "employerAddress.postalCode",
      id: "employerAddress.postalCode",
      label: "Postal Code",
      disabled: isSubmitting
    })))), isRequestingRealTimeQuotes && React.createElement("div", {
      className: "professional-user-agreements",
      ref: electronicDataAgreementDivRef
    }, React.createElement("p", null, "By selecting real-time quotes, you are required to review the Exchange Data Agreement listed below. Please click on the agreement title below to open the agreement in a new tab."), React.createElement("p", null, "By submitting this form, you agree that you have received, read and understand the Exchange Data Agreement, and you agree to all the provisions in the document."), React.createElement(ExternalLink, {
      href: "".concat(rootRestHubUrl, "/Documents/Agreement/ExchangeDataAgreement"),
      onClick: handleAgreementClick
    }, "Exchange Data Agreement")), !useCustomBtnPositioning && React.createElement("p", {
      className: "submit-warning"
    }, SUBMIT_WARNING), !useCustomBtnPositioning && showTempDelayedQuotesWarning && React.createElement("p", {
      className: "temp-delayed-quotes-warning mt-0"
    }, TEMP_DELAYED_QUOTES_WARNING), formErrMsg && !useCustomErrorMsgPositioning && React.createElement("p", {
      className: "error form-error-msg"
    }, formErrMsg), showElectronicDataAgreementValidationMsg && !useCustomErrorMsgPositioning && React.createElement("p", {
      className: "error form-error-msg"
    }, ELECTRONIC_DATA_AGREEMENT_VALIDATION_MSG), !useCustomBtnPositioning ? React.createElement("div", {
      className: "submit-btn-wrapper"
    }, React.createElement(Button, {
      variant: "primary",
      type: "submit",
      disabled: isSubmitting
    }, submitButtonText)) : React.createElement("button", {
      type: "submit",
      disabled: isSubmitting,
      style: {
        display: 'none'
      },
      ref: function ref(node) {
        setSubmitBtnDisabled(!!(node && node.disabled));
        setSubmitBtnText(submitButtonText);
        setSubmitBtnRef(node);
      }
    }));
  })));
};